export default "__VITE_ASSET__BulLsILg__"